import {
  Avatar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import { t } from "i18next";
import appcolors from "../../../constants/Colors";

const tableStyle = {
  "&.MuiTableContainer-root": {
    border: "1px solid grey",
    borderRadius: 1,
    overFlow: "hidden",
  },
  "&.MuiTableContainer-root .MuiTableHead-root": {
    backgroundColor: appcolors.primary,
  },
  "&.MuiTableContainer-root .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root":
    {
      padding: "6px 16px",
      color: appcolors.white,
      fontSize: "1rem",
    },
};

const CompanyDetail = ({ detail }) => {
  return (
    <TableContainer sx={tableStyle}>
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow>
            <TableCell>{t("image")}</TableCell>
            <TableCell>{t("name")}</TableCell>
            <TableCell>{t("email")}</TableCell>
            <TableCell>{t("contact")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row">
              <Avatar
                src={detail?.profileImg}
                sx={{
                  height: 60,
                  width: 60,
                  borderRadius: 2,
                  border: "1px solid grey",
                }}
              />
            </TableCell>
            <TableCell>
              <Typography textTransform={"capitalize"} fontWeight={600}>
                {detail?.name}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography>{detail?.email}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{detail?.contact}</Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CompanyDetail;
